// Funciones de utilidad
// 

export default class FuncLib {

    /**********************
     * UBICACIONES
     **********************/

    // Decriptar ubicación
    CodUbiDecript(ubicacion: string): string {
        if (!ubicacion) return '';

        var ubiTxt: string = '';
        const separatedString = ubicacion.match(/.{0,1}/g);

        if (separatedString !== null) {
            for (let i = 0; i < separatedString.length; i++) {
                if (i === 2) ubiTxt += "Almacen: " + separatedString[0] + separatedString[1];
                if (i === 4) ubiTxt += ", Pasillo: " + separatedString[2] + separatedString[3];
                if (i === 6) ubiTxt += ", Posición: " + separatedString[4] + separatedString[5];
                if (i === 8) ubiTxt += ", Altura: " + separatedString[6] + separatedString[7];
                if (i === 10) ubiTxt += ", Tipo: " + separatedString[8] + separatedString[9];
                if (i === 12) ubiTxt += ", Caja: " + separatedString[10] + separatedString[11];
            }
        }
        return ubiTxt;
    }

    // Función para poner puntos en la ubicación
    punteaUbicacion(input: string): string {
        return input.replace(/(.{2})(?=.)/g, "$1.");
    }


    // Formatear ubicación con grupos 2, 3 y 4 destacados
    // Pasillo, Posición y altura
    formatUbicacion(ubicacion: string | null): string {
        if (!ubicacion) return '';
        const masked = ubicacion.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1.$2.$3.$4.$5.$6');
        if (!masked) return '';
        const partes = masked.split('.');

        // grupos 2, 3 y 4 (índices 1, 2, 3)
        return partes.map((p, i) => {
            return (i >= 1 && i <= 3)
                ? `<span class="ubi-highlight">${p}</span>`
                : p;
        }).join('.');
    }



    /**********************
     * STRINGS
     **********************/

    // Limitar y agregar puntos en un string
    limitarYAgregarPuntos(value: string, maxLength: number): string {
        if (value.length > maxLength) {
            return value.substring(0, maxLength) + '...';
        } else {
            return value;
        }
    }


    // Método para resaltar un texto buscado
    resaltarTexto(value: any, textoDestacado: string): string {
        const valueStr = value != null ? value.toString() : '';

        if (!textoDestacado || !valueStr) {
            return valueStr;
        }

        const textoEscapado = textoDestacado.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

        return valueStr.replace(
            new RegExp(textoEscapado, 'gi'),
            '<span class="resaltado">$&</span>'
        );
    }




}
